import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';

export const ReportsStack = styled(Stack)`
  flex-direction: column;
  gap: 16px;
  padding: 16px;
  width: 90vw;
`;

export const HeaderStack = styled(Stack)`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const NoDataStack = styled(Stack)`
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
`;
